import { render, staticRenderFns } from "./ServiceDetailSummary.vue?vue&type=template&id=9645351a&scoped=true"
import script from "./ServiceDetailSummary.vue?vue&type=script&lang=js"
export * from "./ServiceDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetailSummary.vue?vue&type=style&index=0&id=9645351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645351a",
  null
  
)

export default component.exports